<div class="pagination">
  <div class="pagination__text">
    <span class="pagination__bold">Page {{ currentPage }}</span>
  </div>
  <button class="pagination__left" (click)="lastPage()"></button>
  <button class="pagination__right" (click)="nextPage()"></button>
</div>
